const $ = jQuery;

export default class Header {
    constructor() {
        $('.header__scroll').click(event => {
            event.preventDefault();

            let offset = $(event.currentTarget).closest('.header').height() +
                         $(event.currentTarget).closest('.header').offset().top;

            $('html, body').animate({
                scrollTop: offset
            }, 250);
        });
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/Header.js